<div class="gc-select-combobox" outsideClick (outsideClick)="closeDropdown()"
    [ngClass]="{'gc-select-combobox--multiple': multiple}">
    <div class="gc-select-combobox__input" [ngClass]="{'gc-select-combobox__input--is-opened': isOpened}"
        (click)="openDropdown()">
        <input class="gc-select-combobox__filter-control" [formControl]="filterTextCtrl" autoFocus *ngIf="isOpened"
            (blur)="onFilterTextBlur()" />

        <div class="gc-select-combobox__label-wrapper">
            <div class="gc-select-combobox__label">
                <ng-container *ngIf="selectedItem$ | async; else placeholderTmpl; let selectedItem">
                    <ng-container *ngIf="multiple; else singleSelectedItemTmpl">
                        <div class="gc-badge__list" [hidden]="!selectedItem.length">
                            <div class="gc-badge gc-badge--lg gc-badge--square gc-badge--primary-accent"
                                *ngFor="let item of selectedItem">
                                {{item.label}}

                                <button type="button" class="gc-badge__close-btn" (click)="toggleItem(item)">
                                    <span class="icon-Property-3x-circle"></span>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #singleSelectedItemTmpl>{{selectedItem.label}}</ng-template>
                </ng-container>

                <ng-template #placeholderTmpl>
                    <ng-container *ngIf="placeholder">{{ placeholder }}</ng-container>
                </ng-template>
            </div>
            &nbsp;
        </div>

        <span class="gc-select-combobox__dropdown-icon icon-Property-3cheveron-down" *ngIf="!isDisabled"></span>
    </div>

    <div class="gc-select-combobox__popup" [ngClass]="{'gc-select-combobox__popup--is-opened': isOpened}">
        <div class="gc-select-combobox__list" *ngIf="displayedItems$ | async; let displayedItems">
            <button *ngFor="let item of displayedItems; trackBy: itemsTrackBy" type="button"
                class="gc-select-combobox-item" [ngClass]="{'gc-select-combobox-item--is-selected': item.isSelected}"
                (click)="toggleItem(item)">
                <div class="gc-select-combobox-item__icon" [ngClass]="item.icon" *ngIf="item.icon"></div>
                <span class="gc-select-combobox-item__text">{{item.label}}</span>
            </button>

            <ng-container *ngIf="createItem; else emptyListTmpl">
                <div *ngIf="displayedItems.length" class="gc-select-combobox__divider"></div>
                <button type="button" class="gc-select-combobox-item" (click)="addNewItem()">
                    <div class="gc-select-combobox-item__icon" [ngClass]="createItem.icon" *ngIf="createItem.icon">
                    </div>
                    <span class="gc-select-combobox-item__text text-link">
                        {{createItem.label}}
                    </span>
                </button>
            </ng-container>

            <ng-template #emptyListTmpl>
                <ng-container *ngIf="filterTextCtrl.value && !displayedItems.length">
                    <div class="gc-select-combobox-no-results">
                        <span class="gc-select-combobox-no-results__icon icon-mirror-y icon-Property-3emoji-sad"></span>
                        <span class="gc-select-combobox-no-results__text">
                            {{'SelectComboboxGeneric_NoMatches' | localize: filterTextCtrl.value}}
                        </span>
                    </div>
                </ng-container>
            </ng-template>
        </div>
    </div>
</div>
